<template>
  <label class="fddform-input-radio">
    <input
      v-if="trueLabel || falseLabel"
      v-model="model"
      type="checkbox"
      name="checkbox"
      :true-value="trueLabel"
      :false-value="falseLabel"
      :disabled="disabled"
      @change="handleChange"
    />
    <input
      v-else
      v-model="model"
      type="checkbox"
      name="checkbox"
      :value="label"
      :disabled="disabled"
      @change="handleChange"
    />
    <span class="radio-bg"></span>
    <span class="use-icon_radio"></span>
    <span v-if="$slots.default" class="radio-text">
      <slot></slot>
    </span>
  </label>
</template>
<script>
  export default {
    name: 'FddCheckbox',
    props: {
      value: [String, Number, Boolean],
      label: [String, Number, Boolean],
      trueLabel: [String, Number],
      falseLabel: [String, Number],
      checked: Boolean,
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        selfModel: false
      }
    },
    computed: {
      model: {
        get() {
          return this.isGroup() ? this.store : this.value !== undefined ? this.value : this.selfModel
        },
        set(val) {
          if (this.isGroup()) {
            this.checkboxGroup.$emit('input', val)
          } else {
            this.$emit('input', val)
            this.selfModel = val
          }
        }
      },
      store() {
        return this.checkboxGroup ? this.checkboxGroup.value : this.value
      },
      isChecked() {
        if ({}.toString.call(this.model) === '[object Boolean]') {
          return this.model
        } else if (Array.isArray(this.model)) {
          return this.model.indexOf(this.label) > -1
        } else if (this.model !== null && this.model !== undefined) {
          return this.model === this.trueLabel
        }
        return false
      }
    },
    created() {
      this.checked && this.addToStore()
    },
    methods: {
      handleChange(e) {
        let value
        if (e.target.checked) {
          value = this.trueLabel !== undefined ? this.trueLabel : true
        } else {
          value = this.falseLabel !== undefined ? this.falseLabel : false
        }
        this.$emit('change', value)
        this.$nextTick(function() {
          if (this.isGroup()) {
            this.checkboxGroup.$emit('change', this.checkboxGroup.value)
          }
        })
      },
      addToStore() {
        if (Array.isArray(this.model) && this.model.indexOf(this.label) === -1) {
          this.model.push(this.label)
        } else {
          this.model = this.trueLabel || true
        }
      },
      isGroup() {
        let parent = this.$parent

        while (parent) {
          if (parent.$options.name !== 'FddCheckboxGroup') {
            parent = parent.$parent
          } else {
            this.checkboxGroup = parent
            return true
          }
        }

        return false
      }
    }
  }
</script>
